module.exports = "/images/Turner-Hero.jpg";